function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { useEffect } from 'react';
import { applyHeaderFilters, isRemoteData } from './tableFunctions';
export var useInitialData = function useInitialData(originalData, setData) {
  useEffect(function () {
    if (!isRemoteData(originalData)) {
      setData(_toConsumableArray(originalData));
    }
  }, [originalData, setData]);
};
export var useInitialCheckboxData = function useInitialCheckboxData(selectedData, setSelectedRows) {
  useEffect(function () {
    if (selectedData) {
      setSelectedRows(selectedData);
    }
  }, [selectedData, setSelectedRows]);
};
export var useUpdateDataRemote = function useUpdateDataRemote(originalData, setLoading, setData, filters, setTotalCount, mobile) {
  useEffect(function () {
    if (isRemoteData(originalData)) {
      setLoading(true);
      originalData(filters).then(function (_ref) {
        var resultData = _ref.data,
            totalCount = _ref.totalCount;
        setData(function (prevData) {
          if (!mobile || !filters.loadedResolver) {
            return _toConsumableArray(resultData);
          }

          return prevData.slice(0, filters.startIndex).concat(resultData);
        });
        setTotalCount(totalCount); // Warns the infinity mobile loader list that the new data has been retrieved

        if (mobile && filters.loadedResolver) {
          filters.loadedResolver();
        }

        setLoading(false);
      });
    }
  }, [filters, originalData, setLoading, mobile, setTotalCount, setData]);
};
export var useUpdateDataProp = function useUpdateDataProp(originalData, setLoading, setData, _ref2, setTotalCount) {
  var headerFilters = _ref2.headerFilters,
      ascending = _ref2.ascending,
      sortField = _ref2.sortField,
      sortFunc = _ref2.sortFunc;
  useEffect(function () {
    if (!isRemoteData(originalData)) {
      setLoading(true);
      var filteredData = applyHeaderFilters(originalData, headerFilters, ascending, sortField, sortFunc);
      setTotalCount(filteredData.length);
      setData(filteredData);
      setLoading(false);
    }
  }, [headerFilters, ascending, sortField, originalData, setLoading, setTotalCount, setData, sortFunc]);
};
export var useUpdatePageData = function useUpdatePageData(isRemote, data, setPageData, _ref3) {
  var page = _ref3.page,
      rowsPerPage = _ref3.rowsPerPage;
  useEffect(function () {
    if (isRemote || !rowsPerPage || rowsPerPage === 0) {
      setPageData(data);
    } else {
      setPageData(data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage));
    }
  }, [data, isRemote, page, rowsPerPage, setPageData]);
};